import { render, staticRenderFns } from "./HelperTagList.vue?vue&type=template&id=daa15dde&scoped=true"
import script from "./HelperTagList.vue?vue&type=script&lang=js"
export * from "./HelperTagList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa15dde",
  null
  
)

export default component.exports